const cena = { t: 'Cena', type: 'range', name: 'cena', unit: 'zł', hint: { url: '/price' }}
export default cena